module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gW3ZC"))).then(() => parcelRequire('d0iPb'));